import { render, staticRenderFns } from "./modalViewSquadPlayer.vue?vue&type=template&id=a5993d1a&scoped=true&"
import script from "./modalViewSquadPlayer.vue?vue&type=script&lang=js&"
export * from "./modalViewSquadPlayer.vue?vue&type=script&lang=js&"
import style0 from "./modalViewSquadPlayer.vue?vue&type=style&index=0&id=a5993d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5993d1a",
  null
  
)

export default component.exports